import { getAnalyticsAnonymousId } from "@/feature-gates/bootstrapper";

import { experiments, getExperiment } from "./experiment";

export const getConfTemplatesRelayExperimentWithExposure = (
    experimentConfig:
        | (typeof experiments)["gwpAddRelayToConfluenceTemplatesLanding"]
        | (typeof experiments)["gwpAddRelayToConfluenceTemplateCategories"]
) => {
    const { experimentName } = experimentConfig;
    const experiment = getExperiment(experimentConfig);
    const enrolled = experiment.type == "enrolled";

    // We only want to track exposures from SSR.
    // Client-side exposures are tracked via statsig.
    // NOTE: We're checking `IS_STATIC` because this codepath
    // is only hit from the client during static fallback.
    // @ts-ignore
    if (!globalThis.IS_STATIC) {
        try {
            // @ts-ignore
            globalThis.metrics.increment(`${experimentName}.exposed`, 1, {
                ...experiment,
                analyticsAnonymousId: getAnalyticsAnonymousId()
            });
        } catch (e) {
            if (process.env["NODE_ENV"] !== "test") {
                console.error(`Failed to track ${experimentName} exposure`, e);
            }
        }
    }
    return enrolled && experiment.value;
};
